import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const PaymentMethodsListSkeleton = () => {
  return (
    <section className="flex flex-col flex-1">
      {/* Navigation tabs skeleton */}
      <div className="flex justify-between gap-2 rounded-[10px] p-1 mb-[14px] mx-5">
        <div className="flex-1 rounded-lg px-3 py-2 flex items-center justify-center min-h-[43px]">
          <Skeleton className="h-[27px] w-[60px]" />
        </div>
        <div className="flex-1 rounded-lg px-3 py-2 flex items-center justify-center min-h-[43px]">
          <Skeleton className="h-[27px] w-[40px]" />
        </div>
        <div className="flex-1 rounded-lg px-3 py-2 flex items-center justify-center min-h-[43px]">
          <Skeleton className="h-[27px] w-[70px]" />
        </div>
      </div>

      {/* Payment methods content skeleton */}
      <div className="flex flex-col flex-1 mx-5">
        {/* Express checkout element skeleton */}
        <div className="flex flex-col gap-6 mt-auto">
          <Skeleton className="h-[48px] w-full" />
          
          {/* Saved card options skeleton */}
          <div className="flex flex-col gap-3">
            <Skeleton className="h-[60px] w-full rounded-lg" />
            <Skeleton className="h-[60px] w-full rounded-lg" />
          </div>
          
          {/* Pay button skeleton */}
          <Skeleton className="h-[48px] w-full" />
        </div>
      </div>
    </section>
  );
};

export default React.memo(PaymentMethodsListSkeleton);
